<ng-select
    [(ngModel)]="selectLang"
    [items]="langItems"
    [clearable]="false"
    [markFirst]="false"
    bindLabel="name"
    (change)="updateLang()"
    otbAnnounceSearchResults
></ng-select>
